import React from 'react';
import PropTypes from 'prop-types'
import UserAvatarList from "../../UserAvatarList";
import {employeesTest} from "../../../../helpers/employees-test";
import BankInformationItem from "../../../Atoms/Items/BankInformationItem";
import TableRow from "../../../Wrappers/TableRow";
import TableOptionsButton from "../../TableOptionsButton";

const ApprovalPaymentRow = (props) => {
  const {isApproved} = props
  return (
    <TableRow>
      <p>SF54F</p>
      <UserAvatarList employees={employeesTest}/>
      <BankInformationItem name="Bancolombia"
        type="Cuenta"
        account="123456789"/>
      <p>$5,000,000</p>
      {isApproved ? (
        <a href="#">Ver autorización</a>
      ) : (
        <button className="button micro">Autoriza el pago</button>
      )}
      <TableOptionsButton
        deleteFunction={() => {}}
        editFunction={() => {}}
        seeFunction={() => {}}
      />
    </TableRow>
  );
};

ApprovalPaymentRow.propTypes = {
  isApproved: PropTypes.bool,
}

ApprovalPaymentRow.defaultProps = {
  isApproved: false,
}

export default ApprovalPaymentRow;
